import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const HomeIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>);
const ListIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><circle cx="3" cy="6" r="1.5" fill="currentColor" stroke="none"/><circle cx="3" cy="12" r="1.5" fill="currentColor" stroke="none"/><circle cx="3" cy="18" r="1.5" fill="currentColor" stroke="none"/></svg>);
const StarIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>);
const StatsIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg>);
const UserIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>);

const NAV_ITEMS = [
  { id: 'home', label: 'Home', path: '/', icon: <HomeIcon/> },
  { id: 'exercises', label: 'Exercises', path: '/exercises', icon: <ListIcon/> },
  { id: 'myexercises', label: 'My Studies', path: '/my-exercises', icon: <StarIcon/> },
  { id: 'stats', label: 'Statistics', path: '/stats', icon: <StatsIcon/> },
  { id: 'profile', label: 'Profile', path: '/profile', icon: <UserIcon/> },
];

export default function SidebarNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { signOut } = useAuth();
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const check = () => setIsDesktop(window.innerWidth >= 900);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  if (!isDesktop) return null;

  const activeId = location.pathname === '/' ? 'home'
    : location.pathname.startsWith('/exercises') ? 'exercises'
    : location.pathname.startsWith('/my-exercises') ? 'myexercises'
    : location.pathname.startsWith('/stats') ? 'stats'
    : location.pathname.startsWith('/profile') ? 'profile'
    : 'home';

  return (
    <div className="sidebar-nav" style={{
      position: 'fixed', top: 0, left: 0, bottom: 0, width: 240,
      background: '#0E0C0A', borderRight: '1px solid #1E1C18',
      flexDirection: 'column', padding: '24px 16px', zIndex: 200,
      fontFamily: "'Barlow', sans-serif",
    }}>
      {/* Logo */}
      <div style={{ padding: '12px 12px 24px', borderBottom: '1px solid #1E1C18', marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img src="/logo.png" alt="Drumnasium" style={{ width: 120, height: 120, objectFit: 'contain' }}/>
      </div>

      {/* Nav items */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 4 }}>
        {NAV_ITEMS.map(item => {
          const isActive = activeId === item.id;
          return (
            <button key={item.id} onClick={() => navigate(item.path)}
              style={{
                display: 'flex', alignItems: 'center', gap: 12,
                padding: '11px 14px', borderRadius: 10, border: 'none', cursor: 'pointer',
                background: isActive ? 'rgba(255,85,0,0.12)' : 'transparent',
                color: isActive ? '#FF5500' : '#7A7268',
                fontFamily: "'Barlow', sans-serif", fontSize: 14, fontWeight: isActive ? 700 : 500,
                transition: 'all 0.15s', textAlign: 'left', width: '100%',
              }}>
              {item.icon}
              {item.label}
              {isActive && <div style={{ marginLeft: 'auto', width: 6, height: 6, borderRadius: '50%', background: '#FF5500' }}/>}
            </button>
          );
        })}
      </div>

      {/* Sign out */}
      <button onClick={signOut} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderRadius: 10, border: 'none', cursor: 'pointer', background: 'transparent', color: '#4A4038', fontSize: 13, fontFamily: "'Barlow'", marginTop: 8 }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
        Sign out
      </button>
    </div>
  );
}
